var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeartOutlined = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/24/heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3294 20.7395L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12.6729 20.742C12.2911 21.087 11.7099 21.0859 11.3294 20.7395ZM12.1049 18.5599C16.8698 14.2298 18.3645 12.6902 19.34 10.8749C19.7899 10.0376 20 9.27441 20 8.5C20 6.52457 18.4754 5 16.5 5C15.3777 5 14.2536 5.52835 13.5227 6.38668L12 8.17481L10.4773 6.38668C9.74637 5.52835 8.62227 5 7.5 5C5.52457 5 4 6.52457 4 8.5C4 9.27778 4.21194 10.0443 4.66601 10.8857C5.64456 12.699 7.14926 14.2464 11.8964 18.551L12.0051 18.65L12.1049 18.5599Z",
    fill: "#707D80"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartOutlined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart-outlined.4a7787268c7e3765db2ae0b4326914aa.svg";